import { values } from '@fortem-monorepo/js-utilities';
export const DATABASE = {
    Old: 'old',
    New: 'new',
    Both: 'both',
};
export const DATABASES = values(DATABASE);
export const DATABASE_ENVIRONMENT = {
    Dev: 'dev',
    Prod: 'prod',
};
export const DATABASE_ENVIRONMENTS = values(DATABASE_ENVIRONMENT);
